import { useEffect, useState } from "react";
import { Phone, MessageSquare, ArrowUp } from "lucide-react";
import { useLocation } from "react-router-dom";
import { COMPANY } from "@/lib/site-data";

/** Floating mobile CTA dock + scroll-to-top button. */
export const FloatingCTA = () => {
  const [show, setShow] = useState(false);
  const [showTop, setShowTop] = useState(false);
  const { pathname, hash } = useLocation();

  useEffect(() => {
    const onScroll = () => {
      setShow(window.scrollY > 600);
      setShowTop(window.scrollY > 1200);
    };
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const goToQuote = () => {
    const id = "ajanlat";
    const el = document.getElementById(id);
    if (el) {
      el.scrollIntoView({ behavior: "smooth" });
    } else {
      window.location.href = "/#ajanlat";
    }
  };

  // hide on Kapcsolat page (already a contact-heavy page)
  if (pathname === "/kapcsolat") return null;
  if (hash === "#ajanlat") return null;

  return (
    <>
      {/* Mobile dock */}
      <div
        data-testid="floating-cta"
        className={`fixed bottom-3 left-3 right-3 md:hidden z-40 transition-all duration-300 ${
          show ? "translate-y-0 opacity-100" : "translate-y-24 opacity-0 pointer-events-none"
        }`}
      >
        <div className="floating-dock bg-[#0B192C] rounded-full p-1.5 grid grid-cols-2 gap-1.5">
          <a
            data-testid="floating-cta-call"
            href={`tel:${COMPANY.phoneRaw}`}
            className="flex items-center justify-center gap-2 h-12 rounded-full bg-white/10 hover:bg-white/15 text-white font-semibold text-sm transition"
          >
            <Phone className="w-4 h-4 text-[#EA580C]" />
            Hívás
          </a>
          <button
            data-testid="floating-cta-quote"
            onClick={goToQuote}
            className="flex items-center justify-center gap-2 h-12 rounded-full bg-[#EA580C] hover:bg-[#C2410C] text-white font-semibold text-sm transition"
          >
            <MessageSquare className="w-4 h-4" />
            Ajánlat
          </button>
        </div>
      </div>

      {/* Scroll to top */}
      <button
        data-testid="scroll-top-btn"
        aria-label="Vissza az oldal tetejére"
        onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
        className={`fixed bottom-6 right-6 z-40 w-12 h-12 rounded-full bg-[#1E3E62] hover:bg-[#0B192C] text-white shadow-2xl flex items-center justify-center transition-all duration-300 ${
          showTop ? "translate-y-0 opacity-100" : "translate-y-12 opacity-0 pointer-events-none"
        } hidden md:flex`}
      >
        <ArrowUp className="w-5 h-5" />
      </button>
    </>
  );
};

export default FloatingCTA;
